import { render, staticRenderFns } from "./fbt-project-small.vue?vue&type=template&id=52b5d4da&scoped=true&"
import script from "./fbt-project-small.vue?vue&type=script&lang=js&"
export * from "./fbt-project-small.vue?vue&type=script&lang=js&"
import style0 from "./fbt-project-small.vue?vue&type=style&index=0&id=52b5d4da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5d4da",
  null
  
)

export default component.exports